// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"398":"Faqs","438":"Login","639":"Resume"}[chunkId] + "." + {"398":"e03db5d8","438":"a175788d","639":"18ce51af"}[chunkId] + ".css";
};